// extracted by mini-css-extract-plugin
module.exports = {"title":"AboutYouSection_title__hksbh","phonePrefix":"AboutYouSection_phonePrefix__xRwGp","descriptionText":"AboutYouSection_descriptionText__erbTh"};